const findCircularReferncePath = (targetPortfolio, portfoliosArray) => {
  const graph = {}

  // Step 1: Build the Reverse Graph (Child -> Parents)
  portfoliosArray.forEach(({ id, portfolio_ids = [] }) => {
    portfolio_ids?.forEach((childId) => {
      if (!graph[childId]) graph[childId] = []
      graph[childId].push(id) // Child -> Parent Mapping
    })
  })

  // Step 2: Traverse Upwards to Find All Parents
  const result = new Set()

  function dfs(portfolioId) {
    if (!graph[portfolioId]) return // No parent, stop here
    for (let parentId of graph[portfolioId]) {
      if (!result.has(parentId)) {
        result.add(parentId)
        dfs(parentId) // Recursively find higher-level parents
      }
    }
  }

  dfs(targetPortfolio.id)

  return Array.from(result) // Convert set to array before returning
}

export const mapPortfolios = ({ portfolio, selectedPortfoliosIds, portfolios }) => {
  return {
    id: portfolio.id,
    name: portfolio.name,
    description: portfolio.description,
    location: portfolio.location,
    portfolioValue: portfolio.portfolioValue,
    mappedAccounts: portfolio.accounts_ids?.length || 0,
    accountsIds: portfolio.accounts_ids || [],
    portfolioIds: portfolio.portfolio_ids || [],
    isSelected: selectedPortfoliosIds?.includes(portfolio.id),
    isCounterparty: portfolio.is_external_entity,
    portfolioParents: portfolios.filter((p) => p.portfolio_ids?.includes(portfolio.id)),
    circularReferncePath: findCircularReferncePath(portfolio, portfolios),
  }
}
